import ArtistLogo from "@/fragments/ArtistLogo";
import AppLogo from "@/assets/app-logo.svg";
import MainAppBar from "@/components/MainAppBar";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useArtist } from "@/services/hooks";

export default function PageHeader({ compact = false }) {
  const { artistKey } = useParams();
  const { data: artist } = useArtist(artistKey);

  if (!artistKey) {
    return (
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{ mt: 12, mb: 5 }}
      >
        <img src={AppLogo} alt="Notebook" style={{ width: "100%" }} />
      </Stack>
    );
  }

  if (compact) {
    return <MainAppBar showUserDrawer={false} />;
  }

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ mt: 12, mb: 3 }}
    >
      <ArtistLogo size={32} fitWidth />
      <Avatar
        src={artist?.meta?.profile}
        alt={artistKey}
        sx={{ width: 110, height: 110, mt: 1.5 }}
      />
      <Typography
        variant="body2"
        sx={{
          fontFamily: "'Montserrat Alternates', sans-serif",
          fontWeight: 500,
          color: "text.secondary",
          letterSpacing: "0.18em",
          textTransform: "lowercase",
          fontSize: "0.9rem",
          mt: 1,
        }}
      >
        on notebook
      </Typography>
    </Stack>
  );
}
